<template>
    <div>
        <v-btn v-if="ShowBack" color="white" class="mr-2 selectedbtn" @click="$emit('OnbackClick', $event)">
            <v-icon right dark> mdi-arrow-left-bold </v-icon>
            <span class="button-caption">back</span>
    
        </v-btn>
    
        <v-btn v-if="ShowPreview" color="white" class="mr-2 selectedbtn" @click="$emit('OnPreviewClick', $event)">
            <v-icon right dark color="white"> mdi-file-find </v-icon>
            <span class="button-caption">Preview</span>
    
        </v-btn>
        <v-btn v-if="ShowNext" depressed color="blue" class="selectedbtn" @click="$emit('OnNextClick', $event)">
            <span class="font-weight-bold text-capitalize">Save and Continue</span>
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        onClick: {
            type: Function,
           
        },
         ShowBack: {
                type: Boolean,
                default: true,
            },
            ShowPreview: {
                type: Boolean,
                default: true,
            },
            ShowNext: {
                type: Boolean,
                default: true,
            },
    }
}
</script>
